<template>
    <span class="resource-container" @click="scrollTop;pushResource()">
        <div v-for="resource in resource" v-if="resource.type == '1' || resource.type == '2' || resource.type == '6'">
             <resource-only :data_resource="resource" ref="childComponent"></resource-only>
        </div>
    </span>
</template>
<script>
    import {mapState, mapGetters} from 'vuex'
    import axios from 'axios'
    import ResourceOnly from './resourceOnly.vue'
    export default {
        name: 'resourceStore',
        components: {
            ResourceOnly,
        },
        props:['resource'],
        created(){
            this.pushResource();
        },
        data(){
            return {

            }
        },
        computed: {
            ...mapState,
            ...mapGetters({
                resource_all: 'course/resource_all'
            }),


        },
        methods:{
            pushResource: function () {

                this.$store.commit('course/allResources', (this.resource));
            },
            scrollTop: function () {
                window.scrollTo(0,0);
            }
        }

    }
</script>
<style scoped>
    .resource-container{
        display: flex;;
        flex-direction: column;

    }
    .item-resource-name{
        width: 100%;
        display: flex;
        padding: 10px 10px;

        font-size: 1.2rem;
        cursor: pointer;
        background-color: #fff;

    }
    .item-resource-name:hover{
        background-color: #fff;
    }
</style>